import { render } from "./sk-card.vue?vue&type=template&id=40dc6abe&scoped=true"
const script = {}

import "./sk-card.vue?vue&type=style&index=0&id=40dc6abe&scoped=true&lang=css"

import exportComponent from "D:\\Users\\felipecedillo\\Documents\\GitHub\\marbel-front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-40dc6abe"]])

export default __exports__